class RequestLimitError extends Error {
  // constructor is optional; you should omit it if you just want a custom error
  // type for inheritance and type checking
  constructor(message = 'Something went wrong.') {
    super(message);
    this.name = 'RequestLimitError';
  }
}

export default RequestLimitError;
